module.exports = __webpack_public_path__ + "img/clement-eggs-940-min.0901c4c1.png";